import {Col, Row} from 'react-bootstrap';
import {LuBox} from 'react-icons/lu';
import {BsClockHistory} from 'react-icons/bs';
import {HiOutlineUserGroup} from 'react-icons/hi2';
import {useNavigate} from 'react-router-dom';

const Setting = () => {
  const navigate = useNavigate();

  return (
    <>
      <Row className='sync-logs mt-4'>
        <Col xs={3}>
          <div className='custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
            onClick={() => navigate(`/back-office/settings/order`)}>
            <LuBox size={'24px'} className='me-2' />
              Order
          </div>
        </Col>
        <Col xs={3}>
          <div className=' custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
            onClick={() => navigate(`/back-office/settings/maintenance`)}>
            <BsClockHistory size={'22'} className='me-2' />
              Maintenance
          </div>
        </Col>
        <Col xs={3}>
          <div className='custom-card log-menu-item text-center d-flex align-items-center justify-content-center'
            onClick={() => navigate(`/back-office/settings/emp-close`)}>
            <HiOutlineUserGroup size={'24px'} className='me-2' />
              Employee Close
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Setting;
